import common, { hdmNavlinks } from "./common";
const commonFooter = common();
const { copyright, socialMediaLinks } = commonFooter;

export default { 
	mainFooter: common,
	minimalFooter: {
		socialMediaLinks,
		copyright,
		link: { 
			title: 'Privacy Policy',
			href: '/privacy-policy'
		}
	},
	minimalSocialFooter: { 
		email: 'support@puls.com',
		copyright,
		socialMediaLinks
	},
	hdmFooter: {
		...commonFooter, 
		navLinks: hdmNavlinks,
		stayInTouch: { 
			...commonFooter.stayInTouch,
			formTitle: 'Stay in Touch'
		}
	},
	minimalTermsPrivacyFooter: {
		links: [
			{
				title: 'Terms',
				href: '/terms'
			},
			{
				title: 'Privacy',
				href: '/privacy-policy'
			}
		],
		copyright
	}
}